import { errHandler } from "utils/common";
import api from "utils/api";

export default class KelambuDistribution {
  getAll = (
    opt = {
      page: 1,
      limit: 10,
      search: null,
    }
  ) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/kelambu-distributions`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  getOne = (id) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/kelambu-distributions/${id}`)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  add = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/kelambu-distributions?device=Online", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  update = (payload, id) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/kelambu-distributions/${id}?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  remove = (id) => {
    return new Promise((resolve, reject) => {
      api
        .delete(`/api/kelambu-distributions/${id}?device=Online`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  totalDesk = (urbanvillage_id, year) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/kelambu-distributions-total-desk`, {
          params: { urbanvillage_id, year },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  remainingDesk = (urbanvillage_id, month, year, vector_controll_type) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/kelambu-distribution-remaining`, {
          params: { urbanvillage_id, month, year, vector_controll_type },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
